import { has } from 'lodash';
export function isPageHit(hit) {
  return has(hit, 'isNewTab');
}
export function isEmbeddedSearchProps(props) {
  return typeof props.showFixedQuery === 'string';
}
export let Segment;

(function (Segment) {
  Segment["retailers"] = "retailers";
  Segment["stores"] = "stores";
  Segment["sites"] = "sites";
  Segment["services"] = "services";
  Segment["offers"] = "offers";
  Segment["events"] = "events";
  Segment["news"] = "news";
  Segment["localStories"] = "localStories";
  Segment["nationalStories"] = "nationalStories";
  Segment["centres"] = "centres";
  Segment["onlineServices"] = "onlineServices";
  Segment["nearCentreStores"] = "nearCentreStores";
  Segment["westfieldProducts"] = "westfieldProducts";
  Segment["products"] = "products";
})(Segment || (Segment = {}));